import { useEffect } from "react";

/**
 * SEO meta tags via React 19 native head support.
 * Renders <title>, <meta>, and <link rel="canonical"> into <head>.
 */
export const SEO = ({ title, description, canonical, image }) => {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  return (
    <>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title || "Medskinby"} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="robots" content="index,follow" />
    </>
  );
};
